// // See https://github.com/mui-org/material-ui/tree/master/examples/gatsby
// import React from "react"
// import {Link as MuiLink} from "@material-ui/core"
// import {Link as GatsbyLink} from "gatsby"
import {Link} from "gatsby-theme-material-ui"
// TODO: Switch to direct use of Link when a source stabilizes such as Gatsby Theme or Plugin for Material UI. This may mean waiting for an official first party source.

// function Link(props) {
//   // eslint-disable-next-line
//   return <MuiLink component={GatsbyLink} {...props} />
// }

export default Link
